import { Controller, FieldValues, UseFormReturn } from "react-hook-form";
import GetCheckoutSvg, {
  CheckoutIcons,
} from "../../checkout-icons/GetCheckoutSvg";
import {
  recievingDateFieldName,
  recievingTimeFieldName,
} from "../useCheckoutSubmit";
import { Col, Row } from "@/app/components/lib/my-bootstrap";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { DeliveryMethodsTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useLang } from "@/providers/langProvider";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  form: UseFormReturn<FieldValues, any>;
  recievingFieldName: string;
  delivery_methods: DeliveryMethodsTypes[];
  mobile: boolean;
}

const ReceivingMethodBtns: React.FC<Props> = ({
  form,
  delivery_methods,
  recievingFieldName,
  mobile,
}) => {
  const locale = useLang();
  const t = useTranslation();
  return (
    <>
      <Row className="m-0" style={{ width: mobile ? "100%" : 310 }}>
        {delivery_methods?.map((method, index) => (
          <Col key={index} className="p-0">
            <Controller
              name={recievingFieldName}
              control={form.control}
              rules={{}}
              render={({ field: { value, onChange } }) => (
                <CustomButton
                  type={value === method ? BtnTypes.primary : BtnTypes.gray4}
                  disabled={value !== method}
                  fullWidth
                  size={BtnSizes.large}
                  radius={
                    delivery_methods.length === 2
                      ? index === 0
                        ? locale === "en"
                          ? BtnRadius.left_small
                          : BtnRadius.righ_small
                        : locale === "en"
                        ? BtnRadius.righ_small
                        : BtnRadius.left_small
                      : BtnRadius.none
                  }
                  onClick={() => {
                    form.setValue(recievingDateFieldName, "");
                    form.setValue(recievingTimeFieldName, "");
                    onChange(method);
                  }}
                >
                  {method === DeliveryMethodsTypes.delivery ? (
                    <GetCheckoutSvg
                      svg={CheckoutIcons.delivery}
                      mobile={mobile}
                    />
                  ) : (
                    <GetCheckoutSvg
                      svg={CheckoutIcons.pickup}
                      mobile={mobile}
                    />
                  )}
                  <span style={{ marginInlineStart: 4 }}>{t[method]}</span>
                </CustomButton>
              )}
            />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ReceivingMethodBtns;
